var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { fakeApiCall } from "@ane/core/lib/services/FakeRestResult";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const fake_analysisTemplate = { fakeAnalysisTemplateAbstracts: {} };
class AnalysisTemplateResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/analysis/");
  }
  getTemplatesAbstracts(useFake) {
    return __async(this, null, function* () {
      if (!useFake) {
        const result = yield this._get("templates");
        return result;
      } else {
        const fake = fake_analysisTemplate.fakeAnalysisTemplateAbstracts;
        const myStudy = yield fakeApiCall(
          fake,
          fake ? void 0 : `no fake fakeAnalysisTemplateAbstracts`
        );
        return myStudy;
      }
    });
  }
  readTemplate(templateName) {
    return __async(this, null, function* () {
      const result = yield this._get(`templates/${templateName}`);
      return result;
    });
  }
  saveTemplate(templateContent) {
    return __async(this, null, function* () {
      const userAlias = EnvironmentService.getUser().alias;
      const result = yield this._put({ template: templateContent, UserAlias: userAlias }, `setTemplate`);
      if (!result.isSuccessful()) {
        result.error = result.getRawData();
      }
      return result;
    });
  }
  metricSetCreateOrUpdate(metricSetCreateOrUpdateRequest) {
    return __async(this, null, function* () {
      var _a, _b;
      const result = yield this._put(
        metricSetCreateOrUpdateRequest,
        `metricSets/${metricSetCreateOrUpdateRequest.Name}/createOrUpdate`
      );
      if (!result.isSuccessful()) {
        const rawError = result.getRawData();
        result.error = "Result failed : " + ((_b = (_a = rawError == null ? void 0 : rawError.ExceptionMessage) != null ? _a : rawError == null ? void 0 : rawError.Message) != null ? _b : rawError);
      }
      return result;
    });
  }
}
__decorateClass([
  onError({ message: `An error occurred while retrieving template abstracts.` })
], AnalysisTemplateResource.prototype, "getTemplatesAbstracts", 1);
__decorateClass([
  onError({ message: `An error occurred while retrieving the template.` })
], AnalysisTemplateResource.prototype, "readTemplate", 1);
__decorateClass([
  onError({ message: `An error occurred while saving the template.` })
], AnalysisTemplateResource.prototype, "saveTemplate", 1);
__decorateClass([
  onError({ message: `An error occurred while registering metric set` })
], AnalysisTemplateResource.prototype, "metricSetCreateOrUpdate", 1);
const AnalysisTemplateResource$1 = new AnalysisTemplateResource();
export {
  AnalysisTemplateResource$1 as default
};
//# sourceMappingURL=AnalysisTemplate.resource.js.map
